module.exports = __webpack_public_path__ + "img/20210213_184530.4ebfb536.jpg";